
export default {

  addBudget(state, budget) {
    state.all.unshift(budget)
  },

  setBudgets (state, budgets) {
    state.all = budgets
    state.initialized = true
    state.page = 1
  },

  setCount(state, count) {
    state.count = count
  },

  setCurrentBudget (state, budget) {
    state.current = budget
  },

  setNextBudgets (state, budgets) {    
    state.all = [ ...state.all, ...budgets ]
    state.page++
  },

  updateBudget(state, budget) {
    if ( !state.all ) return
    state.all.forEach(( budgetIterator, index ) => {
      if ( budgetIterator.id === budget.id ) {
        state.all[index] = budget
      }
    });
  }
}